export default __webpack_public_path__ + "static/2292-36b9461e252f5cdb232b2455e653bde6.gif";